import React, { useState, useEffect } from "react";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { RequestBookingService } from '../../services/RequestBookingService'
import { AppContext } from '../../services/AppContext'
import "../../../styles/SelectRoute.css";


interface SelectRouteProps {
  onPress: (isReturnRide: boolean, route: string) => void
}

const SelectRoute: React.FC<SelectRouteProps> = ({ onPress }) => {
  const [selectedRoute, setSelectedRoute] = useState<string>(AppContext.selectedRoute);
  const [isReturnRide, setIsReturnRide] = useState(false);

  useEffect(() => {
    if (AppContext.selectedRoute === "") {
      AppContext.selectedRoute = "PUNE_TO_MUMBAI"
      setSelectedRoute("PUNE_TO_MUMBAI")
      RequestBookingService.getRequestBooking().booking.returnRide = false
      RequestBookingService.getRequestBooking().booking.fromCity = "Pune"
      RequestBookingService.getRequestBooking().booking.toCity = "Mumbai"
      onPress(false, "PUNE_TO_MUMBAI")
    }

  }, [])

  const handleSelect = (route: string) => {
    setSelectedRoute(route);
    let isReturn = false;
    if (route === 'MUMBAI_TO_PUNE') {
      isReturn = false
      AppContext.selectedRoute = 'MUMBAI_TO_PUNE'
      RequestBookingService.getRequestBooking().booking.returnRide = false
      RequestBookingService.getRequestBooking().booking.fromCity = "Mumbai"
      RequestBookingService.getRequestBooking().booking.toCity = "Pune"
    }
    else if (route === 'PUNE_TO_MUMBAI') {
      isReturn = false
      AppContext.selectedRoute = 'PUNE_TO_MUMBAI'
      RequestBookingService.getRequestBooking().booking.returnRide = false
      RequestBookingService.getRequestBooking().booking.fromCity = "Pune"
      RequestBookingService.getRequestBooking().booking.toCity = "Mumbai"
    }
    else if (route === 'RETURN_RIDE') {
      isReturn = true
      AppContext.selectedRoute = 'RETURN_RIDE'
      RequestBookingService.getRequestBooking().booking.returnRide = true
      RequestBookingService.getRequestBooking().booking.fromCity = "Pune"
      RequestBookingService.getRequestBooking().booking.toCity = "Mumbai"
    }
    onPress(isReturn, route)
  };

  const renderRoute = (label: string, routeKey: string) => {
    const isSelected = selectedRoute === routeKey;
    const boxClass = `routeBox ${isSelected ? "selectedRoute" : "unselectedRoute"}`;

    return (
      <div
      className="d-flex flex-row justify-content-between"
      onClick={() => handleSelect(routeKey)}
      style={{ flex: '1 1 0' }}
    >
      <div className={boxClass}>
        <p
          className="mb-2"
          style={{ color: isSelected ? '#0D47A1' : '#000' }}
        >
          {label}
        </p>
        {isSelected ? (
          <CheckCircleIcon color="success" fontSize="large" />
        ) : (
          <CheckCircleOutlineIcon color="action" fontSize="large" />
        )}
      </div>
    </div>
    
    );
  };

  return (
    <div className="d-flex flex-row gap-1 justify-content-between">
      {renderRoute("Pune To Mumbai One Way", "PUNE_TO_MUMBAI")}
      {renderRoute("Mumbai To Pune One Way", "MUMBAI_TO_PUNE")}
      {renderRoute("Pune to Mumbai and Return", "RETURN_RIDE")}
    </div>
  );
};

export default SelectRoute;
